import * as React from "react";

import {logUnreachableCode} from "@khan/logging";

import type {ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions as ActivitySessionsReportRow} from "./__graphql-types__/ActivitySessionsV2Query.ts";
import {DefaultNotApplicable} from "./change-indicator.tsx";
import MasterySkillLevelCell from "./mastery-skill-level-cell.tsx";

interface Props {
    activitySessionsReportRow: ActivitySessionsReportRow;
    onShowDetails: (row: ActivitySessionsReportRow) => void;
}

const ActivityLevelCell: React.FC<Props> = ({
    activitySessionsReportRow,
    onShowDetails,
}) => {
    switch (activitySessionsReportRow.__typename) {
        case "BasicActivitySession":
            return <DefaultNotApplicable />;
        case "MasteryActivitySession":
            return (
                <MasterySkillLevelCell
                    activitySessionsReportRow={activitySessionsReportRow}
                    changes={activitySessionsReportRow.skillLevels}
                    onShowDetails={onShowDetails}
                />
            );
        default:
            logUnreachableCode(
                // @ts-expect-error - TS2339 - Property '__typename' does not exist on type 'never'.
                `Unknown Activity Session type: ${activitySessionsReportRow.__typename}`,
                // @ts-expect-error - TS2339 - Property '__typename' does not exist on type 'never'.
                activitySessionsReportRow.__typename,
            );
            return null;
    }
};

export default ActivityLevelCell;
